export const PHISHING_ROUTES_NAMES = {
  phishingBadge: 'phishing-badge',
  confirmPhishingBadge: 'phishing-badge-confirm',
  rejectPhishingBadge: 'phishing-badge-reject',
};
